import { BASE_URL } from './Config.js';

export class ContactService {
  createContact = async (data) => {
    const token = localStorage.getItem('accessToken');
    if (!token) throw new Error('Token manquant');

    const res = await fetch(`${BASE_URL}/contact/create`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      },
      body: JSON.stringify(data)
    });

    if (!res.ok) {
      const errText = await res.text();
      throw new Error(errText || 'Erreur création contact');
    }
    return res.json();
  };

  getAllContacts = async () => {
    const token = localStorage.getItem('accessToken');
    const res = await fetch(`${BASE_URL}/contact/all`, {
      method: 'GET',
      headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` }
    });
    if (!res.ok) throw new Error('Erreur chargement');
    return res.json();
  };

  getContactById = async (id) => {
    const token = localStorage.getItem('accessToken');
    const res = await fetch(`${BASE_URL}/contact/${id}`, {
      method: 'GET',
      headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` }
    });
    if (!res.ok) throw new Error('Erreur chargement détail');
    return res.json();
  };

 updateContact = async (id, data) => {
    const token = localStorage.getItem('accessToken');
    if (!token) throw new Error('Token manquant');

    const res = await fetch(`${BASE_URL}/contact/update/${id}`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      },
      body: JSON.stringify(data)
    });

    if (!res.ok) {
      const errText = await res.text();
      throw new Error(errText || 'Erreur mise à jour contact');
    }
    return res.json();
  };

  deleteContact = async (id) => {
    const token = localStorage.getItem('accessToken');
    const res = await fetch(`${BASE_URL}/contact/delete/${id}`, {
      method: 'DELETE',
      headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` }
    });
    if (!res.ok) throw new Error('Erreur suppression');
    return true;
  };

  getContactsByClientId = async (clientId) => {
    const token = localStorage.getItem('accessToken');
    if (!token) throw new Error('Token manquant');

    const res = await fetch(`${BASE_URL}/contact/client/${clientId}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      }
    });

    if (!res.ok) throw new Error('Erreur chargement contacts du client');
    return res.json();
  };

  getContactsByFournisseurId = async (fournisseurId) => {
    const token = localStorage.getItem('accessToken');
    if (!token) throw new Error('Token manquant');

    const res = await fetch(`${BASE_URL}/contact/fournisseur/${fournisseurId}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      }
    });

    if (!res.ok) throw new Error('Erreur chargement contacts du fournisseur');
    return res.json();
  };
}